import { render, staticRenderFns } from "./ekko.home.vue?vue&type=template&id=b042b40a&scoped=true&"
import script from "./ekko.home.vue?vue&type=script&lang=ts&"
export * from "./ekko.home.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.home.vue?vue&type=style&index=0&id=b042b40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b042b40a",
  null
  
)

export default component.exports